import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Row, Col, Card, CardBody, Button, FormGroup, Label } from "reactstrap";
import { Form, Input } from '@availity/form';
import Select from "react-select";
import DatePicker from "react-datepicker";
import DataTable from 'react-data-table-component';
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useImperativeHandle, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from '@fortawesome/free-solid-svg-icons';
import * as yup from "yup";
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.css'
import { lavakleenApi } from "../../api/lavakleenApi";
import { PageTitle } from '../../layout/components/PageTitle';
import { convertArrayOfObjectsToCSV, deleteDataFromApi, filterDataFromApi, getDataFromApi } from '../../api/providers/providers';
import { columnsVisits } from '../providers/salesProviders';
import { ModalComponent } from '../components/ModalComponent';
import { useSelector } from 'react-redux';
import { forwardRef } from 'react';

const headers = {
    'Authorization' : 'Bearer ' + localStorage.getItem('sToken'),
    'private' : localStorage.getItem('idCompany')
}

export const VisitsPage = forwardRef( (props, ref) => {
    useImperativeHandle( ref, () => ({
        async filterData(values){
            const result = await filterDataFromApi('Visit/getVisitsList', values, headers);
            setData(result.visitList)
        },

        async restore() {
            await getVisits()
        }
    }) )

    const navigate = useNavigate();

    const usersRef = useRef(null);
    const customersRef = useRef(null);

    const [modalState, setModalState] = useState({
        isOpen: false,
        backDrop: true,
        saveDataToEndpoint: ''
    })

    const [data, setData] = useState([]);
    const { id, isProcessing, role } = useSelector( state => state.auth )
    const [formData, setFormData] = useState({
        id: 0,
        idCustomer: null,
        idDriver: null,
        sComments: '',
    });

    const [selectedOptionCustomer, setSelectedOptionCustomer] = useState(null);
    const [selectedOptionChofer, setSelectedOptionChofer] = useState(null);
    const [visitDate, setVisitDate] = useState(new Date());

    const [optionsCustomers, setOptionsCustomers] = useState([]);
    const [optionsChofer, setOptionsChofer] = useState([]);

    const [userPermissions, setUserPermissions] = useState(JSON.parse( localStorage.getItem('userPermissions') ))
    const [permission, setPermission] = useState(null)

    //validators
    const [invalidCustomer, setInvalidCustomer] = useState(true);
    const [invalidChofer, setInvalidChofer] = useState(true);

    const [columns, setColumns] = useState([...columnsVisits, {
        name: "Opciones",
        cell: (row) => (
            <>
                <Button onClick={ () => editRow(row) } color="primary">
                    <i className="lnr-pencil"></i>
                </Button>
                <Button color="success" onClick={ () => closeVisit(row) }>
                    <FontAwesomeIcon
                        icon={faToggleOn}
                    />
                </Button>
                <Button color="danger" onClick={ () => deleteRow(row.idVisit) }><i className="lnr-trash"></i></Button>
            </>
        ),
        sortable: false,
        ignoreRowClick: true,
        button: true,
    }])

    const toggleModal = (saveDataToEndpoint) => {
        setModalState({
            ...modalState,
            isOpen: !modalState.isOpen,
            saveDataToEndpoint,
        })
    }

    const onAddClick = () => {
        setFormData({
            id: 0,
            idCustomer: null,
            idDriver: null,
            sComments: '',
        });

        setSelectedOptionCustomer(null)
        setSelectedOptionChofer(null)

        setInvalidCustomer(true)
        setInvalidChofer(true)
        
        toggleModal('Visit/addVisit')
    }

    const getVisits = async () => {
        await lavakleenApi.get('Visit/getVisitsList', {
            headers
        }).then( response => {
            setData( response.data.visitList );
        } )
    }

    const getDropdownData = async () => {
        const customers = await getDataFromApi(`Customer/getCustomerList?filterIdStatusCustomer=1`, 0, [], headers)
        if(customers.status === 'success') {
            const optionsArray = []
            customers.customerList.map( option => {
                optionsArray.push({value: option.idCustomer, label: `${option.sCompanyName}`})
            } )
            
            customersRef.current = optionsArray
            setOptionsCustomers( optionsArray )
        }

        let filter = ''
        if(role !== 1)
            filter = `&idCompany=${localStorage.getItem('idCompany')}`

        const chofers = await getDataFromApi(`User/getUsersList?idRol=6&idStatusUser=1${filter}`, 0, [], headers)
        if(chofers.status === 'success') {
            const optionsArray = []
            chofers.userList.map( option => {
                optionsArray.push({value: option.idUser, label: `${option.sName}`})
            } )
            usersRef.current = optionsArray
            setOptionsChofer( optionsArray )
        }
    }

    const editRow = async(row) => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Visitas')

        if(userPerm.bEdit !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })
            return
        }

        if(row.sStatus === 'Cerrada') {
            Swal.fire({
                title: 'Error',
                text: 'La visita ya fue cerrada, no es posible editarla.',
                icon: 'error',
            })
            return
        }

        const visit = await getDataFromApi(`Visit/findVisit?idVisit=${row.idVisit}`, row.idVisit, {}, headers);
        if(visit.status === 'success'){
            const userAssigned = usersRef.current.find( element => element.value === visit.visitData.idDriver )
            setSelectedOptionChofer(userAssigned)
            setInvalidChofer(false)

            const customer = customersRef.current.find( element => element.value === visit.visitData.idCustomer )
            setSelectedOptionCustomer(customer)
            setInvalidCustomer(false)

            setFormData( {...visit.visitData, id: visit.visitData.idVisit} );
            toggleModal('Visit/editVisit')
        }
    }

    const deleteRow = async (idVisit) => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Visitas')

        if(userPerm.bDelete !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: "¿Está seguro de realizar esta acción?.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, realizarla!'
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                const result = await deleteDataFromApi(`Visit/deleteVisit?idVisit=${idVisit}`, headers)
                if(result.bResult === true)
                    await getVisits()
            }
        })
    }

    const downloadCsv = () => {
        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV(data);
        const BOM = "\uFEFF";
        if (csv == null) return;
        
        const filename = 'visitas.csv';

        if (!csv.match(/^data:text\/csv/i)) {
            csv = `data:text/csv;charset=utf-8,${BOM + csv}`;
        }
        
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
    }

    const checkPermissions = async () => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Visitas')
        setPermission(userPermissions.find( userPermission => userPermission.sModuleDetail === 'Visitas'))
        
        if(userPerm.bList !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })

            navigate(`/pages/dashboard`)
            return
        }
        
        await getVisits();
        await getDropdownData();
    }

    const closeVisit = async (row) => {
        const userPerm = userPermissions.find( userPermission => userPermission.sModuleDetail === 'Visitas')

        if(userPerm.bEdit !== true) {
            Swal.fire({
                title: 'Error',
                text: 'No tienes permisos para usar esta función',
                icon: 'error',
            })
            return
        }

        if(row.sStatus === 'Cerrada') {
            Swal.fire({
                title: 'Error',
                text: 'La visita ya fue cerrada.',
                icon: 'error',
            })
            return
        }

        Swal.fire({
            title: 'Aviso',
            text: "¿Está seguro de realizar esta acción?.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, realizarla!'
        })
        .then(async (result) => {
            if(result.isConfirmed) {
                const bIsOpenVisit = false
                await lavakleenApi.post(`Visit/changeVisitStatus`, {idVisit: row.idVisit, bIsOpenVisit}, {
                    headers
                }).then( response => {
                    if(response.data.bResult == true && response.data.sErrors.length == 0) {
                        getVisits()
                    }
                } )
            }
        })
    }

    useEffect(() => {
        checkPermissions();
        
    }, [])
    
    return (
        <>
            <TransitionGroup>
                <CSSTransition
                    component="div"
                    classNames="TabsAnimation"
                    appear={true}
                    timeout={1500} enter={false} exit={false}>
                        <div>
                            <PageTitle
                                heading="Visitas"
                                subheading="Gestion de visitas a tus clientes"
                                icon="lnr-users icon-gradient bg-ripe-malin"
                            />
                            <ul className="body-tabs body-tabs-layout tabs-animated body-tabs-animated nav">
                                {
                                    permission !== null && permission.bCreate === true
                                    ? (
                                        <li className="nav-item">
                                            <Button className="mb-2 me-2" color="primary"
                                                onClick={ onAddClick }
                                            >
                                                Agregar
                                            </Button>
                                        </li>
                                    )
                                    : ''
                                }

                                {
                                    permission !== null && permission.bExport === true
                                    ? (
                                        <li className="nav-item">
                                            <Button className="mb-2 me-2" color="danger"
                                                onClick={ () => downloadCsv()}
                                            >
                                                Exportar
                                            </Button>
                                        </li>
                                    )
                                    : ''
                                }
                            </ul>
                            <Row>
                                <Col md="12">
                                    <Card className="main-card mb-3">
                                        <CardBody>
                                        <DataTable data={data}
                                            columns={columns}
                                            pagination
                                            fixedHeader
                                            fixedHeaderScrollHeight="500px"
                                        />
                                        </CardBody>
                                    </Card>
                                </Col>
                                <ModalComponent
                                    isOpen={modalState.isOpen}
                                    toggle={ toggleModal }
                                    backdrop={ modalState.backDrop }
                                    modalTitle="Registrar visita"
                                    size="lg"
                                    initialValues={formData}
                                    validationSchema={ {
                                        sComments: yup.string().required(),
                                    } }
                                    saveDataToEndpoint={ modalState.saveDataToEndpoint }
                                    getDataFunction={ getVisits }
                                    alertMessages={ { addMessage: 'Visita registrada exitosamente', updateMessage: 'Visita actualizada exitosamente' } }
                                    dropDownsToValidate={ [ { field: 'idDriver', value: selectedOptionChofer?.value}, { field: 'idCustomer', value:  selectedOptionCustomer?.value} ] }
                                >
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup className="mb-2">
                                                <Label for="idCustomerType">Cliente</Label>
                                                <Select
                                                    defaultValue={selectedOptionCustomer}
                                                    options={optionsCustomers}
                                                    isClearable
                                                    name="idCustomerType"
                                                    key={ selectedOptionCustomer }
                                                    placeholder="Selecciona una opción"
                                                    className={ invalidCustomer ? 'is-invalid form-control' : '' }
                                                    onChange={ (option) => {
                                                        option == null ? setInvalidCustomer(true) : setInvalidCustomer(false)
                                                        setSelectedOptionCustomer(option)
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label for="idCustomerType">Chofer</Label>
                                                <Select
                                                    defaultValue={selectedOptionChofer}
                                                    options={optionsChofer}
                                                    isClearable
                                                    name="idCustomerType"
                                                    key={ selectedOptionChofer }
                                                    placeholder="Selecciona una opción"
                                                    className={ invalidChofer ? 'is-invalid form-control' : '' }
                                                    onChange={ (option) => {
                                                        option == null ? setInvalidChofer(true) : setInvalidChofer(false)
                                                        setSelectedOptionChofer(option)
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label for="idCustomerType">Fecha visita</Label>
                                                <DatePicker
                                                    className="form-control"
                                                    dateFormat="yyyy-MM-dd"
                                                    selected={ visitDate }
                                                    onChange={(date) => setVisitDate(date)}
                                                    minDate={new Date()}
                                                    readOnly
                                                />
                                            </FormGroup>
                                            <FormGroup className="mb-2">
                                                <Label for="sComments">Comentario</Label>
                                                <Input type="textarea" name="sComments" placeholder=""/>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </ModalComponent>
                            </Row>
                        </div>
                </CSSTransition>
            </TransitionGroup>
        </>
    )
})
